import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { Button } from '@/components';
import { AuthLayout } from './AuthLayout';

export interface SignInProps {
  customerName: string;
}

export const SignIn: React.FC<SignInProps> = ({ customerName }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
    if (signInError) {
      setError(signInError.message);
      setBusy(false);
    }
    // On success the auth listener in App swaps this screen out.
  }

  return (
    <AuthLayout
      eyebrow="Sign in"
      title="Welcome back"
      lede={`Sign in to the ${customerName} workspace.`}
    >
      <form className="auth__form" onSubmit={onSubmit}>
        <div className="auth__field">
          <label className="field-label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            className="text-input"
            value={email}
            autoComplete="username"
            autoFocus
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="auth__field">
          <label className="field-label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            type="password"
            className="text-input"
            value={password}
            autoComplete="current-password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="auth__field-aside">
            <Link to="/auth/forgot-password">Forgot password?</Link>
          </div>
        </div>

        {error && (
          <div className="auth__error" role="alert">
            {error}
          </div>
        )}

        <Button type="submit" variant="primary" fullWidth loading={busy}>
          Sign in
        </Button>
      </form>
    </AuthLayout>
  );
};

export default SignIn;
